import { Box, Loader } from '@mantine/core'

interface CardOverlayProps {
  loading: boolean
  children: React.ReactNode
}

export function CardOverlay({ loading, children }: CardOverlayProps) {
  return (
    <Box style={{ position: 'relative' }}>
      {children}
      {loading && (
        <Box
          style={{
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(255,255,255,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
            borderRadius: 4,
          }}
        >
          <Loader size="sm" />
        </Box>
      )}
    </Box>
  )
}
